window.initRequestFromParam = function(path, id_param) {
  if(getParameterByName(id_param)){
    $.get(`${path}/${getParameterByName(id_param)}`);
  }
}

